/* global axios */
import ApiClient from './ApiClient';

class RealEstateCommissionPlansAPI extends ApiClient {
  constructor() {
    super('real_estate_commission_plans', { accountScoped: true });
  }

  updateByTransaction(transactionId, commissionPlan) {
    return axios.patch(`${this.url}/${transactionId}`, {
      commission_plan: commissionPlan,
    });
  }
}

export default new RealEstateCommissionPlansAPI();
